var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWelcome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 890,
    height: 460,
    viewBox: "0 0 890 460",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M481.05 263.451V248.788H407.736V249.705V263.451V381.67V396.333H422.399H481.05V381.67H422.399V263.451H481.05Z",
    fill: "#002945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.791 248.788V396.333H590.105V248.788H516.791ZM575.442 381.67H531.453V263.451H575.442V381.67Z",
    fill: "#CA91C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.344 381.67V249.705H298.681V381.67V396.333H313.344H371.995V381.67H313.344Z",
    fill: "#CA91C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.69 263.451V248.788H192.376V249.705V263.451V314.771V329.434V381.67V396.333H207.039H265.69V381.67H207.039V329.434H265.69V314.771H207.039V263.451H265.69Z",
    fill: "#002945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M839.372 263.451V248.788H766.058V249.705V263.451V314.771V329.434V381.67V396.333H780.721H839.372V381.67H780.721V329.434H839.372V314.771H780.721V263.451H839.372Z",
    fill: "#CA91C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.889 249.705V370.89L104.228 332.23L104.14 332.319L104.058 332.237L64.535 371.76V249.247H49.872V395.875H64.535V392.496L104.147 352.884L142.889 391.627V396.333H157.552V249.705H142.889Z",
    fill: "#002945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.488 249.705V253.083L677.876 292.695L639.133 253.953V249.247H624.47V395.875H639.133V274.689L677.794 313.35L677.883 313.261L677.964 313.342L717.488 273.819V396.333H732.15V249.705H717.488Z",
    fill: "#002945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.076 159.38C340.046 159.38 344.076 155.35 344.076 150.38C344.076 145.409 340.046 141.38 335.076 141.38C330.105 141.38 326.076 145.409 326.076 150.38C326.076 155.35 330.105 159.38 335.076 159.38Z",
    fill: "#002945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.076 259.38C118.046 259.38 122.076 255.35 122.076 250.38C122.076 245.409 118.046 241.38 113.076 241.38C108.105 241.38 104.076 245.409 104.076 250.38C104.076 255.35 108.105 259.38 113.076 259.38Z",
    fill: "#CA91C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.076 459.38C296.046 459.38 300.076 455.35 300.076 450.38C300.076 445.409 296.046 441.38 291.076 441.38C286.105 441.38 282.076 445.409 282.076 450.38C282.076 455.35 286.105 459.38 291.076 459.38Z",
    fill: "#002945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.076 186.38C522.046 186.38 526.076 182.35 526.076 177.38C526.076 172.409 522.046 168.38 517.076 168.38C512.105 168.38 508.076 172.409 508.076 177.38C508.076 182.35 512.105 186.38 517.076 186.38Z",
    fill: "#CA91C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.076 451.38C787.046 451.38 791.076 447.35 791.076 442.38C791.076 437.409 787.046 433.38 782.076 433.38C777.105 433.38 773.076 437.409 773.076 442.38C773.076 447.35 777.105 451.38 782.076 451.38Z",
    fill: "#002945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.076 215.38C796.046 215.38 800.076 211.35 800.076 206.38C800.076 201.409 796.046 197.38 791.076 197.38C786.105 197.38 782.076 201.409 782.076 206.38C782.076 211.35 786.105 215.38 791.076 215.38Z",
    fill: "#002945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.076 377.38C682.046 377.38 686.076 373.35 686.076 368.38C686.076 363.409 682.046 359.38 677.076 359.38C672.105 359.38 668.076 363.409 668.076 368.38C668.076 373.35 672.105 377.38 677.076 377.38Z",
    fill: "#CA91C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 889.076,
    height: 459.38,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcome);
export default __webpack_public_path__ + "static/media/welcome.afbe57c1ed098cf31b88779c7ef0b35b.svg";
export { ForwardRef as ReactComponent };